/*
 * Determines if an array contains the specified item
 */
Array.prototype.contains = function (item) {
    if (!this || !(this instanceof Array))
        return false;

    for (var i = 0; i < this.length; i++) {
        if (this[i] === item) return true;
    }

    return false;
};